/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Current_Trip_Started_AtInputs */

const vi_vehicle_current_trip_started_at = /** @type {(inputs: Vehicle_Current_Trip_Started_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khởi hành`)
};

/**

* @param {Vehicle_Current_Trip_Started_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_current_trip_started_at = /** @type {((inputs?: Vehicle_Current_Trip_Started_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Current_Trip_Started_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_current_trip_started_at(inputs)
});